import { render, staticRenderFns } from "./LogosMarcas.vue?vue&type=template&id=cf2130d6&scoped=true"
import script from "./LogosMarcas.vue?vue&type=script&lang=js"
export * from "./LogosMarcas.vue?vue&type=script&lang=js"
import style0 from "./LogosMarcas.vue?vue&type=style&index=0&id=cf2130d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2130d6",
  null
  
)

export default component.exports